import React from 'react';
import Card from '../Card';

/**
 * V4 M21 F.5：课程推送 CTA 卡（设计文档 3.6 节）。
 *
 * 渲染条件由 V4P5 上层 truthy 判断（rec 为 null/undefined 不渲染本卡）。
 * P0 默认后端不写 rec 字段，超管在 AIStrategyConfig 勾上
 * enable_student_course_recommendation 后由 generate_report_v4 写入。
 *
 * rec schema（设计文档 CourseRec TypedDict）：
 *   { title, description, target_dim, cta_label, cta_url }
 */
export default function CourseCTACard({ rec, onTrack }) {
  if (!rec) return null;

  const title = rec.title || '推荐课程';
  const description = rec.description || '';
  const ctaLabel = rec.cta_label || '了解详情';
  const ctaUrl = rec.cta_url || '';

  const handleClick = () => {
    if (typeof onTrack === 'function') {
      try { onTrack(); } catch { /* tracking 不影响跳转 */ }
    }
  };

  return (
    <Card
      data-testid="report-v4-p5-course-cta"
      style={{
        padding: '20px 28px',
        marginBottom: 24,
        borderTop: '3px solid #7c3aed',
        background: '#faf5ff',
      }}
    >
      <h3 style={{ fontSize: 14, fontWeight: 700, color: '#7c3aed', marginTop: 0, marginBottom: 8 }}>
        {title}
      </h3>
      {description && (
        <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.7, margin: '0 0 12px' }}>
          {description}
        </p>
      )}
      {ctaUrl && (
        <a
          href={ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          style={{
            display: 'inline-block',
            padding: '8px 18px',
            background: '#7c3aed',
            color: '#fff',
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          {ctaLabel}
        </a>
      )}
    </Card>
  );
}
